// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__2isSi","lastUpdated":"PrivacyPolicy_lastUpdated__3Zhvd"};